module.exports = __webpack_public_path__ + "img/03.6e8de1d3.jpg";